module.exports = __webpack_public_path__ + "media/moonlamp.d903838d.mp4";